import { Component, OnInit , ElementRef, ViewChild} from '@angular/core';
import { UploadServiceService } from '../service/upload-service.service';
import { ActivatedRoute ,Router } from '@angular/router';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

interface Category {
  typeId: string;
  type: string;
}

interface SubCategory {
  subTypeId: string;
  subType: string;
}

interface SubCategorySet {
  categoryId: string;
  subCategoryList: SubCategory[];
  timeline: number;
  defaultLevel: number;
  defaultNumberOfQuestion: number;
  defaultPercentage: number;
}

type AssessmentState = 'DRAFT' | 'PUBLISHED';

interface AssessmentObject {
  ageGroup: string;
  assessmentTitle: string;
  categoryList: Category[];
  assessmentTimeline: number;
  subCategoryList: SubCategorySet[];
  subCategoryListObject: { [key: string]: any };
  state: AssessmentState;
}

@Component({
    selector: 'app-assessment-builder',
    templateUrl: './assessment-builder.component.html',
    styleUrls: ['./assessment-builder.component.css'],
    standalone: false
})
export class AssessmentBuilderComponent implements OnInit {
  assessmentId: string | null = null;
  categoryListSet: Category[] = [];
  subCategoryListSet: SubCategorySet[] = [];
  typeArray: Category[] = [];
  typeArraySubList: { [key: string]: SubCategory[] } = {};
  
  assessmentObject: AssessmentObject = {
    ageGroup: null,
    assessmentTitle: null,
    categoryList: null,
    assessmentTimeline: null,
    subCategoryList: [],
    subCategoryListObject: {},
    state: 'DRAFT'
  };

  // Material Chips Configuration
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  categoryListCtrl = new FormControl<string>('');
  filteredCategory: Observable<Category[]>;

  @ViewChild('categoryInput') categoryInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  // Existing arrays for dropdowns
  ageGroupList: any = [
    {value: '4-5', viewValue: '4-5 Years'},
    {value: '5-6', viewValue: '5-6 Years'},
    {value: '6-7', viewValue: '6-7 Years'},
    {value: '7-8', viewValue: '7-8 Years'},
    {value: '8-9', viewValue: '8-9 Years'},
    {value: '9-10', viewValue: '9-10 Years'},
    {value: '10-11', viewValue: '10-11 Years'},
    {value: '11-12', viewValue: '11-12 Years'}
  ];
  times: any = [
    {value:  5, viewValue: '5 Mins'},
    {value:  6, viewValue: '6 Mins'},
    {value:  7, viewValue: '7 Mins'},
    {value:  8, viewValue: '8 Mins'},
    {value: 9,  viewValue: '9 Mins'},
    {value: 10, viewValue: '10 Mins'},
    {value: 15, viewValue: '15 Mins'},
    {value: 20, viewValue: '20 Mins'}
  ];

  numberOfQuestion: any = [
    {value:  4, viewValue: '4 Questions'},
    {value:  5, viewValue: '5 Questions'},
    {value:  6, viewValue: '6 Questions'},
    {value:  7, viewValue: '7 Questions'},
    {value:  8,  viewValue:'8 Questions'},
    {value:  9, viewValue: '9 Questions'},
    {value: 10, viewValue: '10 Questions'},
    {value: 11, viewValue: '11 Questions'}
  ];

  percentage: any = [
    {value:  40, viewValue: '40%'},
    {value:  50, viewValue: '50%'},
    {value:  60, viewValue: '60%'},
    {value:  70, viewValue: '70%'},
    {value:  80,  viewValue:'80%'},
    {value:  90, viewValue: '90%'},
    {value: 100, viewValue: '100%'},

  ];

  levels: any = [
    {value: 1, viewValue: 'Level 1'},
    {value: 2, viewValue: 'Level 2'},
    {value: 3, viewValue: 'Level 3'},
    {value: 4, viewValue: 'Level 4'},
    {value: 5, viewValue: 'Level 5'},
    {value: 6, viewValue: 'Level 6'},
    {value: 7, viewValue: 'Level 7'},
    {value: 8, viewValue: 'Level 8'}
  ];
  fruits = [
    {name: 'Lemon'},
    {name: 'Lime'},
    {name: 'Apple'},
  ];
  /**
   * assessmentId = generatedAssessmentName
   * assessmentName = "Maths-AGE-1" ,
   * ageGroup = "4-5",
   * categoryList = ["Maths","Cognitive"],
   * assessmentTimeline = 20 min(s)
   * subCategoryList = {
   *                     "Maths":{
   *                              "subCategoryList":["Subtraction","Multiplication"],
   *                               "timeline":10,
   *                               "defaultLevel":3
   *                             },
   *                    "Cognitive":{
   *                              "subCategoryList":["Visual","Spatial"],
   *                               "timeline":10,
   *                               "defaultLevel":3
   *                             }
   *                    }
   **/
  /** Testing **/

  // Testing overal 
  constructor(private _uploadService: UploadServiceService, private route: ActivatedRoute,private router:Router) {
    this.filteredCategory = this.categoryListCtrl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : (value as Category)?.type;
        return name ? this._filter(name as string) : this.typeArray.slice();
      })
    );
  }

  ngOnInit(): void {
    const assessmentId = this.route.snapshot.queryParamMap.get('assessmentId');
    if (assessmentId) {
      this.loadExistingAssessment(assessmentId);
    }
    this.loadCategories();
  }

  private loadExistingAssessment(assessmentId: string): void {
    // Preserve the backend identifier so edits and state changes update this record.
    this.assessmentId = assessmentId;
    this._uploadService.getAssessmentById(assessmentId).subscribe({
      next: (data: any) => {
        if (data?.resp) {
          this.assessmentObject = {
            ...data.resp,
            state: data.resp.state === 'PUBLISHED' ? 'PUBLISHED' : 'DRAFT',
          };
          this.categoryListSet = this.assessmentObject.categoryList;
          this.subCategoryListSet = this.assessmentObject.subCategoryList;
          this.categoryListSet.forEach(category => {
            this.loadSubTypes(category.typeId);
          });
        }
      },
      error: (error) => console.error('Error loading assessment:', error)
    });
  }

  private loadCategories(): void {
    this._uploadService.getAllTypes().subscribe({
      next: (data: any) => {
        this.typeArray = data?.resp || [];
      },
      error: (error) => console.error('Error loading categories:', error)
    });
  }

  createAssessment(state: AssessmentState = this.assessmentObject.state): void {
    if (!this.isValidObj(this.assessmentObject)) {
      alert('Please fill in all required fields');
      return;
    }

    this.assessmentObject.categoryList = this.categoryListSet;
    this.assessmentObject.subCategoryList = this.subCategoryListSet;
    this.assessmentObject.assessmentTimeline = this.calculateAssessmentTimeline(this.subCategoryListSet);

    if (!this.assessmentId) {
      this.assessmentId = this.generateAssessmentId(this.assessmentObject.assessmentTitle);
    }

    // The backend stores this value as `state`, but its create/update contract
    // expects the legacy request key `assessemntState`.
    const { state: _currentState, ...assessmentDetails } = this.assessmentObject;
    const payload = {
      ...assessmentDetails,
      assessemntState: state,
      flow_selected: 'create-assessment',
      assessmentId: this.assessmentId
    };

    this._uploadService.createAssessment(JSON.stringify(payload)).subscribe({
      next: () => {
        this.assessmentObject.state = state;
        alert(state === 'PUBLISHED'
          ? 'Assessment published successfully'
          : 'Assessment saved as draft successfully');
      },
      error: (error) => {
        console.error('Error creating assessment:', error);
        alert('Failed to create assessment. Please try again.');
      }
    });
  }

  toggleAssessmentState(): void {
    const nextState: AssessmentState = this.isPublished ? 'DRAFT' : 'PUBLISHED';
    this.createAssessment(nextState);
  }

  get isPublished(): boolean {
    return this.assessmentObject.state === 'PUBLISHED';
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const selectedCategory = event.option.value as Category;
    if (this.categoryListSet.some(cat => cat.typeId === selectedCategory.typeId)) {
      return; // Category already exists
    }

    this.categoryListSet.push(selectedCategory);
    this.categoryInput.nativeElement.value = '';
    this.categoryListCtrl.setValue(null);

    // Add new subcategory set with default values
    this.subCategoryListSet.push({
      categoryId: selectedCategory.typeId,
      subCategoryList: [],
      timeline: 10,
      defaultLevel: 1,
      defaultNumberOfQuestion: 4,
      defaultPercentage: 50
    });

    // Load subtypes for the selected category
    this.loadSubTypes(selectedCategory.typeId);
  }

  private loadSubTypes(categoryId: string): void {
    this._uploadService.getAllSubtypesByType(categoryId).subscribe({
      next: (data: any) => {
        this.typeArraySubList[categoryId] = data?.resp || [];
      },
      error: (error) => console.error('Error loading subtypes:', error)
    });
  }

  onSubTypeSelection(event: any, categoryId: string): void {
    const subCatSet = this.subCategoryListSet.find(set => set.categoryId === categoryId);
    if (!subCatSet) return;

    const selectedSubType = this.typeArraySubList[categoryId]?.find(
      subType => subType.subTypeId === event.value
    );

    if (selectedSubType && !subCatSet.subCategoryList.some(
      item => item.subTypeId === selectedSubType.subTypeId
    )) {
      subCatSet.subCategoryList.push(selectedSubType);
    }
  }

  remove(categoryId: string): void {
    this.categoryListSet = this.categoryListSet.filter(category => category.typeId !== categoryId);
    this.subCategoryListSet = this.subCategoryListSet.filter(subCat => subCat.categoryId !== categoryId);
  }

  removeSubCat(subType: SubCategory, categoryId: string): void {
    const subCatSet = this.subCategoryListSet.find(set => set.categoryId === categoryId);
    if (subCatSet) {
      subCatSet.subCategoryList = subCatSet.subCategoryList.filter(
        item => item.subTypeId !== subType.subTypeId
      );
    }
  }

  private _filter(value: string): Category[] {
    const filterValue = value.toLowerCase();
    return this.typeArray.filter(category => 
      category.type.toLowerCase().includes(filterValue)
    );
  }

  private calculateAssessmentTimeline(subCategoryList: SubCategorySet[]): number {
    return subCategoryList.reduce((total, subCat) => total + (subCat.timeline || 0), 0);
  }

  private generateAssessmentId(assessmentTitle: string): string {
    return assessmentTitle
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/-+$/, '');
  }

  isValidObj(object: any): boolean {
    if (!object) return false;
    
    // Check required fields
    if (!object.ageGroup || !object.assessmentTitle) {
      return false;
    }

    // Check if categories are selected
    if (!this.categoryListSet || this.categoryListSet.length === 0) {
      return false;
    }

    // Check if each category has at least one subcategory selected
    if (!this.subCategoryListSet || this.subCategoryListSet.length === 0) {
      return false;
    }

    for (const subCatSet of this.subCategoryListSet) {
      if (!subCatSet.subCategoryList || subCatSet.subCategoryList.length === 0) {
        return false;
      }
    }

    return true;
  }

  deleteAssessment() {
    if (confirm('Are you sure you want to delete this assessment?')) {
      // get assessmentId from the r
      const assessmentId = this.route.snapshot.queryParamMap.get('assessmentId');
      if (!assessmentId) {
        alert('No assessment ID found to delete.');
        return;
      }
      this._uploadService.deleteAssessment(assessmentId).subscribe({
        next: () => {
          alert('Assessment deleted successfully');
          // redirect to /assessment-builder
          this.router.navigate([`//assesments`]);

        },
        error: (error) => {
          console.error('Error deleting assessment:', error);
          alert('Failed to delete assessment. Please try again.');
        }
      });
    }
  }
}
